<template>
    <div class="float-left mr-1" v-if="mostrarAprovacao">
        <span class="text-success">
            <i
                class="fa fa-comments-o fa-lg icon-button mr-1"
                title="Detalhar Aproção"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" size="lg">
            <div slot="modal-title">
                Serviço Aprovado - {{ comprometimento.idComprometimento }}
            </div>
            <b-row>
                <b-col sm="12">
                    <comprometimento-dados
                        :comprometimento="comprometimento"
                    ></comprometimento-dados>
                    <comprometimento-documentacao
                        class="mt-4"
                        v-model="comprovacoes"
                        :comprometimento="comprometimento"
                        v-if="comprometimento.contratoTipoEspecial"
                        :naoPermiteEditar="naoPermiteEditar"
                    ></comprometimento-documentacao>
                    <comprometimento-pesquisa
                        class="mt-2"
                        v-model="avaliacoes"
                        :comprometimento="comprometimento"
                        :naoPermiteEditar="naoPermiteEditar"
                    >
                    </comprometimento-pesquisa>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import ComprometimentoDocumentacao from './ComprometimentoDocumentacao'
import ComprometimentoPesquisa from './ComprometimentoPesquisa'
import ComprometimentoDados from './ComprometimentoDados'
import { comprometimentoStatus } from './ComprometimentoStatus'

export default {
    components: {
        ComprometimentoDocumentacao,
        ComprometimentoPesquisa,
        ComprometimentoDados
    },

    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            mostrarModal: false,
            comprovacoes: null,
            avaliacoes: null
        }
    },

    methods: {
        abrirModal() {
            this.comprovacoes = {
                comprovacao01: this.comprometimento.comprovacao01,
                comprovacao02: this.comprometimento.comprovacao02
            }
            this.avaliacoes = { avaliacoes: this.comprometimento.avaliacoes }
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        }
    },

    computed: {
        naoPermiteEditar() {
            return this.comprometimento.status == comprometimentoStatus.APROVADO
        },

        mostrarAprovacao() {
            return (
                this.comprometimento.status == comprometimentoStatus.APROVADO &&
                this.comprometimento.avaliacoes &&
                this.comprometimento.avaliacoes.length > 0
            )
        }
    }
}
</script>
